import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "./SpecialDeals.css";

// const deals = [
//   {
//     id: 1,
//     title: "Weekend Special",
//     discount: "25% OFF",
//     image: "/assets/images/vehicles/vehicle7.jpg",
//     bgClass: "deal-blue",
//     countdownClass: "count-blue",
//     endDate: "2027-01-01T00:00:00",
//     description:
//       "Book any car from Friday to Sunday and enjoy 25% off your total rental. Perfect for your weekend getaway!",
//     features: [
//       "Available on all vehicle categories",
//       "Free additional driver",
//       "Unlimited mileage",
//     ],
//     oldPrice: "$59/day",
//     newPrice: "$44/day",
//   },
//   {
//     id: 2,
//     title: "Monthly Saver",
//     discount: "20% OFF",
//     image: "/assets/images/vehicles/vehicle8.jpg",
//     bgClass: "deal-red",
//     countdownClass: "count-red",
//     endDate: "2028-01-01T00:00:00",
//     description:
//       "Rent any vehicle for a month or longer and save big with our exclusive long-term rental discount.",
//     features: [
//       "20% Monthly Discount",
//       "Free Insurance Upgrade",
//       "Free Delivery",
//     ],
//     oldPrice: "$1200/month",
//     newPrice: "$960/month",
//   },
//   {
//     id: 3,
//     title: "Yearly Saver",
//     discount: "15% OFF",
//     image: "/assets/images/vehicles/vehicle9.jpg",
//     bgClass: "deal-green",
//     countdownClass: "count-green",
//     endDate: "2027-02-01T00:00:00",
//     description:
//       "Enjoy 15% off when you book a vehicle for a full year. Perfect for long-term business travel.",
//     features: [
//       "Free Additional Driver",
//       "Unlimited Mileage",
//       "24/7 Support",
//     ],
//     oldPrice: "$2999/year",
//     newPrice: "$2454/year",
//   },
// ];

const deals = [
  {
    id: 1,
    title: "Mumbai Airport Transfers",
    discount: "24×7",
    image: "/images/services/airport.jpg",
    bgClass: "deal-blue",
    countdownClass: "count-blue",
    endDate: "2030-01-01",
    description:
      "On-time airport pickup and drop service from Mumbai and Navi Mumbai Airport.",
    features: [
      "Flight Tracking",
      "Professional Chauffeurs",
      "Doorstep Pickup",
    ],
    oldPrice: "Always",
    newPrice: "Available",
  },

  {
    id: 2,
    title: "Outstation Cab Service",
    discount: "Popular",
    image: "/images/services/outstation.jpg",
    bgClass: "deal-red",
    countdownClass: "count-red",
    endDate: "2030-01-01",
    description:
      "Comfortable one-way and round-trip taxi service across Maharashtra & India.",
    features: [
      "One Way",
      "Round Trip",
      "Multi Day Tour",
    ],
    oldPrice: "Premium",
    newPrice: "Service",
  },

  {
    id: 3,
    title: "Corporate Travel",
    discount: "Business",
    image: "/images/services/corporate.jpg",
    bgClass: "deal-green",
    countdownClass: "count-green",
    endDate: "2030-01-01",
    description:
      "Professional transportation solutions for companies and corporate executives.",
    features: [
      "Monthly Contract",
      "Office Pickup",
      "Dedicated Fleet",
    ],
    oldPrice: "24×7",
    newPrice: "Support",
  },
];
function Countdown({ targetDate }) {
  const calculateTimeLeft = () => {
    const difference = new Date(targetDate) - new Date();

    if (difference <= 0) {
      return {
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
      };
    }

    return {
      days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(
        2,
        "0"
      ),
      hours: String(
        Math.floor((difference / (1000 * 60 * 60)) % 24)
      ).padStart(2, "0"),
      minutes: String(
        Math.floor((difference / (1000 * 60)) % 60)
      ).padStart(2, "0"),
      seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, "0"),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="countdown-grid">
      <div className="count-box">
        <h4>{timeLeft.days}</h4>
        <p>Days</p>
      </div>

      <div className="count-box">
        <h4>{timeLeft.hours}</h4>
        <p>Hours</p>
      </div>

      <div className="count-box">
        <h4>{timeLeft.minutes}</h4>
        <p>Minutes</p>
      </div>

      <div className="count-box">
        <h4>{timeLeft.seconds}</h4>
        <p>Seconds</p>
      </div>
    </div>
  );
}

function SpecialDeals() {
  return (
    <section className="special-section">
      <div className="container">

        <div className="section-title">

          <div className="title-lines">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <h2>Special Deals & Promotions</h2>

          <p>
            Don't miss these limited-time rental offers. Save more and enjoy
            premium travel with our exclusive discounts.
          </p>

        </div>

        <Swiper
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          loop={true}
          spaceBetween={30}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
        >
          {deals.map((deal) => (
            <SwiperSlide key={deal.id}>

              <div className={`deal-card ${deal.bgClass}`}>

                <div
                  className="deal-image"
                  style={{ backgroundImage: `url(${deal.image})` }}
                >
                  <span className="discount-badge">
                    {deal.discount}
                  </span>

                  <button className="rent-btn">
                    Rent Now
                  </button>
                </div>

                <div className="deal-content">

                  <h3>{deal.title}</h3>

                  <p>{deal.description}</p>

                  <ul className="feature-list">
                    {deal.features.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>

                  <div className={`countdown-wrapper ${deal.countdownClass}`}>
                    <Countdown targetDate={deal.endDate} />
                  </div>

                  <div className="price-box">

                    <span className="old-price">
                      {deal.oldPrice}
                    </span>

                    <span className="new-price">
                      {deal.newPrice}
                    </span>

                  </div>

                </div>

              </div>

            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
}

export default SpecialDeals;